import { MessageCircle, Flower2, Truck } from "lucide-react";

const steps = [
  {
    icon: Flower2,
    title: "Escolha o modelo",
    desc: "Selecione a coroa que melhor representa sua homenagem em nosso catálogo com mais de 28 referências.",
  },
  {
    icon: MessageCircle,
    title: "Personalize a faixa",
    desc: "Escreva a mensagem de homenagem que será impressa na faixa — sem custo adicional.",
  },
  {
    icon: Truck,
    title: "Entrega expressa",
    desc: "Confirmamos pelo WhatsApp e entregamos em até 2h no velório, capela ou endereço informado.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="como-funciona" className="py-20 md:py-32">
      <div className="container-wide">
        <div className="max-w-2xl">
          <span className="overline">Como funciona</span>
          <h2 className="font-serif text-4xl md:text-5xl text-[#2D4A3E] leading-tight mt-3">
            Três passos simples para encomendar com tranquilidade
          </h2>
          <p className="mt-5 text-[#5C5C5C] leading-relaxed">
            Sabemos que é um momento delicado. Por isso facilitamos cada etapa do pedido — você fala com uma pessoa real,
            não com um robô.
          </p>
        </div>

        <ol className="mt-14 grid md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <li key={s.title} className="relative bg-white border border-[#E5E3DB] rounded-2xl p-8">
              <span className="absolute -top-4 -left-4 font-serif text-7xl text-[#BFA573]/30 leading-none select-none">
                {String(i + 1).padStart(2, "0")}
              </span>
              <s.icon className="h-7 w-7 text-[#2D4A3E]" strokeWidth={1.5} />
              <h3 className="font-serif text-2xl text-[#2D4A3E] mt-5">{s.title}</h3>
              <p className="text-[#5C5C5C] mt-3 leading-relaxed text-sm">{s.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
